import { Link } from 'react-router-dom';

export function SinPermiso() {
  return (
    <div className="min-h-screen bg-calbucura-gray-light flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <h1 className="text-2xl font-bold text-calbucura-black mb-3">
          Sin permiso
        </h1>
        <p className="text-gray-700 mb-6">
          Tu cuenta no tiene permiso para ver esta página. Si crees que es un
          error, contacta a la comisión.
        </p>
        <Link
          to="/"
          className="inline-block bg-calbucura-orange hover:bg-calbucura-orange-dark text-white font-semibold py-2 px-4 rounded-md transition-colors"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
